"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ComponentBase_1 = require("./ComponentBase");

var SvgElement =
/** @class */
function (_super) {
  __extends(SvgElement, _super);

  function SvgElement(props) {
    return _super.call(this, props) || this;
  }

  SvgElement.prototype.getBaseSvgProps = function (defaults, overrides) {
    var baseSvgProps = this.props.baseSvgProps;
    return __assign(__assign(__assign({}, defaults), baseSvgProps), overrides);
  };

  SvgElement.prototype.getElementSvgProps = function (defaults, overrides) {
    var _a = this.props,
        theme = _a.theme,
        children = _a.children,
        className = _a.className,
        componentStyle = _a.componentStyle,
        componentStyleProps = _a.componentStyleProps,
        configuration = _a.configuration,
        hide = _a.hide,
        baseSvgProps = _a.baseSvgProps,
        svgProps = __rest(_a, ["theme", "children", "className", "componentStyle", "componentStyleProps", "configuration", "hide", "baseSvgProps"]);

    return __assign(__assign(__assign({}, defaults), svgProps), overrides);
  };

  SvgElement.prototype.getNumber = function (val) {
    return typeof val === 'string' ? parseInt(val, 10) : val;
  };

  return SvgElement;
}(ComponentBase_1.ComponentBase);

exports.SvgElement = SvgElement;